import { useState, useEffect } from 'react';
import { API_ROUTES } from '_app/api';
import useSWR from 'swr';
// import getInitLang from '@/utils/getInitLang';

export function useLanguage(shortname) {
  const { data: languages } = useSWR(
    API_ROUTES.languages.used(shortname),
  );

  const [activeLang, setActiveLang] = useState(null);

  // useEffect(() => {
  //   if (languages?.length) {
  //     const defaultLang = getInitLang(languages || [], undefined);

  //     if (defaultLang) setActiveLang(defaultLang);
  //   }
  // }, [languages]);

  const onActiveLangChange = (value) => {
    setActiveLang(value);
  };

  return {
    activeLang,
    onActiveLangChange,
    languages,
  };
}
